import React, { useEffect, useRef, useState } from "react";
import { Checkbox, FormControlLabel, Grid } from "@mui/material";
import { AutocompleteInput, BooleanInput, ReferenceInput, SelectInput, useSourceContext } from "react-admin";
import { useFormContext, useWatch } from "react-hook-form";
import { administrationRequests } from "api/administrationApi";
import { googleRequests } from "api/googleApi";

const RoomInput = ({ classTypeId, disciplineId }) => {
  const sourceContext = useSourceContext();
  const { setValue } = useFormContext();

  const [showAllDepartmentRooms, setShowAllDepartmentRooms] = useState(false);

  const roomSource = sourceContext.getSource("roomId");
  const googleCourseSource = sourceContext.getSource("googleCourseRefId");
  const isOnline = useWatch({ name: sourceContext.getSource("isOnline") });

  // Only one of the two room fields applies at a time, so the inactive one is null
  const previousIsOnline = useRef(isOnline);
  useEffect(() => {
    const flipped = previousIsOnline.current !== isOnline;
    previousIsOnline.current = isOnline;

    if (!isOnline) {
      setValue(googleCourseSource, null, { shouldDirty: false });
    } else if (flipped) {
      setValue(roomSource, null, { shouldDirty: false });
    }
  }, [isOnline, roomSource, googleCourseSource, setValue]);

  if (!classTypeId) return null;

  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        xs={12}
        md={2}
      >
        <BooleanInput
          source="isOnline"
          label="Google зала?"
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        {isOnline ? (
          <ReferenceInput
            source="googleCourseRefId"
            reference={googleRequests.getGoogleRoomsSelect()}
          >
            <SelectInput
              optionText="name"
              label="Google зала"
              fullWidth
            />
          </ReferenceInput>
        ) : (
          <ReferenceInput
            source="roomId"
            reference={administrationRequests.getRoomsSelect()}
            filter={{
              classTypes: classTypeId,
              ...(disciplineId && !showAllDepartmentRooms ? { departmentDisciplineId: disciplineId } : {}),
            }}
          >
            <AutocompleteInput
              label="Зала"
              optionValue="id"
              optionText={rec =>
                `${rec.roomName} (Номер на зала: ${rec.roomNumber || ""}) ${rec.buildingName} (Капацитет занятия: ${
                  rec.capacityClasses || ""
                })`
              }
              filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
              fullWidth
            />
          </ReferenceInput>
        )}
      </Grid>
      {disciplineId && !isOnline && (
        <Grid
          item
          xs={12}
          md={4}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={showAllDepartmentRooms}
                onChange={e => setShowAllDepartmentRooms(e.target.checked)}
              />
            }
            label="Зали от всички катедри"
          />
        </Grid>
      )}
    </Grid>
  );
};

export default RoomInput;
